import { ExtendedCarItemType } from '@/interfaces/cars.interfaces';

const getCarDealerComment = (extendedData: ExtendedCarItemType) => {
  const { description } = extendedData.data;
  return description;
};

export default getCarDealerComment;
